// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__7FJBr","container":"Contact_container__wVlEi"};